module.exports = __webpack_public_path__ + "img/joining-the-team.2e93eab5.png";